import { action, computed } from 'mobx';
import PagedCollection from 'core/model/PagedCollection';

const VIEW_DROPDOWN_DISCREET_FILTER_NAME = 'view-projects-dropdown';

class ProjectsFilterCollection extends PagedCollection {
  @action
  filter(query = undefined, options = {}) {
    if (query !== undefined) {
      this.resetDiscreteFilters();
      super.filter(query, options);
      this.applyPagination();
    }

    if (query === undefined) {
      super.filter(query, options);
    }

    return this.models;
  }

  getSortValue = (field, model) => model.get(field);

  @computed
  get selectedProjectIds() {
    return this.selectedArray.map((model) => model.get('projectId')) ?? [];
  }

  @action
  showAllProjects() {
    this.removeDiscreteFilter(VIEW_DROPDOWN_DISCREET_FILTER_NAME);
    this.applyPagination();
  }

  @action
  selectProjects(projectIds) {
    this.clearSelection();

    projectIds.forEach((id) => {
      const model = this.unfiltered.find((m) => m.get('projectId') === id);
      model?.select({ multi: true });
    });

    this.applyPagination();
  }

  @action
  addGroupFilter(projectIds) {
    this.selectProjects(projectIds);
    this.addDiscreteFilter({
      type: 'group-dropdown',
      fn: (projectModel) => projectIds.includes(projectModel.get('projectId'))
    });

    this.applyPagination();
  }

  @action
  removeGroupFilter() {
    this.removeDiscreteFilter('group-dropdown');
    this.applyPagination();
  }

  @action
  showSelectedProjects() {
    this.addDiscreteFilter({
      type: VIEW_DROPDOWN_DISCREET_FILTER_NAME,
      fn: (projectModel) => projectModel.isSelected
    });

    this.applyPagination();
  }

  @action
  selectAll(options) {
    if (this.selectedSize > 0 && !this.isAllSelected) {
      this.clearSelection();
    }

    this.original.forEach((model) => {
      if (this.selectedSize > 0 && model.isSelected) {
        model.select(options);
      }

      if (this.selectedSize === 0 && !model.isSelected) {
        model.select(options);
      }
    });
  }

  @action
  reset(options = {}) {
    super.reset(options);
    this.clearSelection();
  }

  @action
  resetDiscreteFilters() {
    super.resetDiscreteFilters();
    this.applyPagination();
  }
}

export default ProjectsFilterCollection;
